"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coshDocs = void 0;
var coshDocs = exports.coshDocs = {
  name: 'cosh',
  category: 'Trigonometry',
  syntax: ['cosh(x)'],
  description: 'Compute the hyperbolic cosine of x in radians.',
  examples: ['cosh(0.5)'],
  seealso: ['sinh', 'tanh', 'coth']
};